// Helpers to parse "garde" week labels and detect the current week.
// Week labels look like: "SEMAINE DU SAMEDI 25 AVRIL AU VENDREDI 01 MAI 2026"
// They may span two months (e.g. April → May), which the previous naive logic
// did not handle.

const MONTHS = {
  JANVIER: 0,
  FEVRIER: 1,
  'FÉVRIER': 1,
  MARS: 2,
  AVRIL: 3,
  MAI: 4,
  JUIN: 5,
  JUILLET: 6,
  AOUT: 7,
  'AOÛT': 7,
  SEPTEMBRE: 8,
  OCTOBRE: 9,
  NOVEMBRE: 10,
  DECEMBRE: 11,
  'DÉCEMBRE': 11,
};

/**
 * Parse a week label and return { start: Date, end: Date } or null.
 * Tolerates the optional year ("... 01 MAI 2026") — defaults to current year.
 */
export const parseWeekRange = (label, today = new Date()) => {
  if (!label) return null;
  const u = label.toUpperCase();
  const re = /(\d{1,2})\s+([A-ZÉÛ]+).*?\bAU\b.*?(\d{1,2})\s+([A-ZÉÛ]+)(?:\s+(\d{4}))?/;
  const m = u.match(re);
  if (!m) return null;
  const sDay = parseInt(m[1], 10);
  const sMon = MONTHS[m[2]];
  const eDay = parseInt(m[3], 10);
  const eMon = MONTHS[m[4]];
  if (sMon === undefined || eMon === undefined) return null;
  // The year is on the right (end side). When the start month is greater than
  // the end month, the range crosses the new year (e.g., late December →
  // early January) and the start date is in the previous year.
  const endYear = m[5] ? parseInt(m[5], 10) : today.getFullYear();
  const startYear = sMon > eMon ? endYear - 1 : endYear;
  const start = new Date(startYear, sMon, sDay, 0, 0, 0, 0);
  const end = new Date(endYear, eMon, eDay, 23, 59, 59, 999);
  return { start, end };
};

/** Return true if `today` falls within the [start, end] range of the label. */
export const isCurrentWeek = (label, today = new Date()) => {
  const r = parseWeekRange(label, today);
  return !!(r && today >= r.start && today <= r.end);
};

/** Sort week labels chronologically by their parsed start date. */
export const sortWeeksChronologically = (weeks, today = new Date()) =>
  [...weeks].sort((a, b) => {
    const ra = parseWeekRange(a, today);
    const rb = parseWeekRange(b, today);
    return (ra ? ra.start.getTime() : 0) - (rb ? rb.start.getTime() : 0);
  });
